import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useDataLayerValue } from "../../../DataLayer/DataLayer";
import Layout from "../../../Layout";
import HeaderBread from "../../../components/HeaderBread";
import CustomHeaderTitle from "../../../components/constants/CustomHeaderTitle";
import PopupInput from "../../../components/PopupInput/PopupInput";
import { getPopupData } from "../../../utils/ApiCalls/Popup";

const EditPopup = () => {
  const params = useParams();
  const [popup, setPopup] = useState({});
  const [relatedPopups, setRelatedPopups] = useState([]);
  const [, dispatch] = useDataLayerValue();

  const navigation = [
    { title: "Home", route: "/" },
    { title: "Popup List", route: "/website/webpages/popup" },
    { title: "Edit Popup", route: "/website/webpages/popup/edit" },
  ];

  useEffect(() => {
    getData(params?.id);
  }, [params]);

  const getData = async (id) => {
    dispatch({ type: "SET_LOADING", loading: true });
    const data = await getPopupData({ id });
    if (data.error) {
      dispatch({ type: "SET_ERROR_MESSAGE", errMess: { message: data.error, type: "error" } });
    } else if (data.count === 1) {
      const current = data.data[0];
      setPopup(current);

      if (current.english_image) {
        const related = await getPopupData({ english_image: current.english_image, limit: 100, page: 1 });
        if (!related.error) {
          setRelatedPopups(related.data || []);
        }
      }
    }
    dispatch({ type: "SET_LOADING", loading: false });
  };

  return (
    <Layout type={"update_per"} module_data={"Popup"}>
      <CustomHeaderTitle title={"Edit Popup"} />
      <HeaderBread navigation={navigation} title={"Edit Popup"} />
      {popup?.id && <PopupInput popup={popup} relatedPopups={relatedPopups} />}
    </Layout>
  );
};

export default EditPopup;
